import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductsListComponent } from 'ish-shared/components/product/products-list/products-list.component';

import { RecentlyModule } from '../../recently.module';

import { RecentlyPageComponent } from './recently-page.component';

const recentlyPageRoutes: Routes = [
  {
    path: '',
    component: RecentlyPageComponent,
    data: {
      meta: {
        title: 'application.recentlyViewed.heading',
        robots: 'noindex, nofollow',
      },
      breadcrumbData: [{ key: 'application.recentlyViewed.breadcrumb.label' }],
    },
  },
];

@NgModule({
  imports: [ProductsListComponent, RouterModule.forChild(recentlyPageRoutes), RecentlyModule],
  declarations: [RecentlyPageComponent],
})
export class RecentlyPageModule {}
